module.exports = __webpack_public_path__ + "img/Y1.bbac32b8.png";